<ng-container *ngIf="cs.vm$ | async as vm">
  <ng-container *ngIf="vm.category; else categoryForm">
    <div
      class="cover mt-4 p-4 flex justify--space-between"
      *ngIf="vm.isLT || vm.initialFormsData?.lt"
    >
      Loss & theft cover
      <span class="typog-body-bold text-nowrap"
        >£ {{ vm.basketItem.coverPrice | number: '1.2-2' }}</span
      >
    </div>
    <div
      class="mt-8"
      *ngIf="
        vm.initialFormsData?.imei ||
        vm.isComplete ||
        vm.category !== deviceCategoryEnum.MobilePhone
      "
    >
      <sky-device-detail
        (removeDevice)="handleRemoveDevice(vm.basketItem)"
        [deviceCategory]="vm.category"
        [deviceId]="vm.basketItem.id"
        [deviceName]="vm.basketItem.title"
        [numberOfDevices]="numberOfDevices"
      ></sky-device-detail>
    </div>

    <ng-container *ngIf="!vm.isComplete">
      <div
        class="mt-8"
        *ngIf="
          vm.category === deviceCategoryEnum.MobilePhone &&
          !vm.initialFormsData?.imei
        "
      >
        <sky-imei-section
          (search)="handleIMEISearch($event)"
          [isImeiInvalid]="isImeiInvalid"
          [imeiNumbersInBasket]="allImeisInBasket"
        ></sky-imei-section>
      </div>

      <div class="mt-8" *ngIf="vm.initialFormsData?.imei">
        <sky-mobile-info
          [brand]="vm.initialFormsData?.brandName"
          [phoneModel]="vm.initialFormsData?.phoneModel"
          [imei]="vm.initialFormsData?.imei"
        ></sky-mobile-info>
      </div>

      <ng-container
        *ngIf="
          vm.initialFormsData?.imei ||
          vm.category !== deviceCategoryEnum.MobilePhone
        "
      >
        <div class="mt-8">
          <sky-ui-device-form
            (form)="cs.deviceForm($event)"
            [deviceCategory]="vm.category"
            [deviceTypes]="deviceTypes[vm.category]"
            [brands]="vm.activeBrands"
          ></sky-ui-device-form>
        </div>

        <div class="mt-8">
          <sky-lost-theft-form
            *ngIf="
              isEngineerJourney &&
              vm.isLTAllowed &&
              !hasAllLTIncludedDevices &&
              vm.category === 'Mobile Phone'
            "
            (formChanges)="cs.lossAndTheftFormChanges($event)"
            [initialValue]="vm.initialFormsData?.lt"
            [amount]="vm.basketItem.coverPrice"
          ></sky-lost-theft-form>
        </div>
        <dgx-components-button
          class="mt-8"
          disableMode="disable"
          [disabled]="!vm.isDeviceFormValid"
          (click)="handleAddDevice(!vm.isDeviceFormValid)"
          (keydown.enter)="handleAddDevice(!vm.isDeviceFormValid)"
          >Add to basket
          <ng-container *ngIf="vm.basketItem.price"
            >+ £ {{ vm.basketItem.price | number: '1.2-2' }}</ng-container
          ></dgx-components-button
        >
      </ng-container>
      <!--// this work around will be removed next release-->
      <div class="mt-8" *ngIf="!isFirstVirtual">
        <a class="link" (click)="chooseDifferentDevice()"
          >Choose a different device</a
        >
      </div>
    </ng-container>
  </ng-container>

  <ng-template #categoryForm>
    <!--// this work around will be removed next release-->
    <div class="mt-8" *ngIf="!isFirstVirtual">
      <sky-ui-category-form
        (formChanges)="selectCategory($event)"
        [categories]="deviceCategories"
      ></sky-ui-category-form>
    </div>
  </ng-template>
</ng-container>
